import { render, staticRenderFns } from "./TestingPage.vue?vue&type=template&id=abc0ae04&scoped=true"
import script from "./TestingPage.vue?vue&type=script&lang=js"
export * from "./TestingPage.vue?vue&type=script&lang=js"
import style0 from "./TestingPage.vue?vue&type=style&index=0&id=abc0ae04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abc0ae04",
  null
  
)

export default component.exports